/**
* All rights Reserved, Designed By www.feidai.com
* @Title: login.ts
* @Package: 
* @author: 青瞳科技
* @date: 2025/12/08 15:31:00
* @version: V1.0
* @Copyright: 2019 www.feidai.com Inc. All rights reserved.
* @Belong To: 青瞳科技
* 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
*/
const login = {
  state: {
    // 登录账号和密码存储，下次登录回填
    mobile: '',
    password: ''
  },

  mutations: {
    SET_LOGIN_INFO: (state: any, res: any) => {
      const { mobile, password } = res
      state.mobile = mobile;
      state.password = password;
    }
  },

  actions: {
    setLoginInfo ({ commit }: any, res: any) {
      commit("SET_LOGIN_INFO", res)
    }
  }
};

export default login;
